export default __webpack_public_path__ + "static/The Home_Image 7_carousel 2@2x-543a5da697f41831da9a2089874697e4.jpg";